import styled, { css } from 'styled-components';

import Base from './base';
import theme from './theme';

const withCard = css`
  border-radius: ${Styles.borderRadius};
  background-color: ${Styles.color.white};
  box-shadow: ${Styles.boxShadow};
`;

const AuthContainer = styled(Base)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;

  ${Styles.desktop`
    ${theme.isCardDesktop && withCard}
  `}

  h1,
  h2 {
    text-transform: ${Styles.textTransform.headlines};
  }
  hr {
    border-color: ${Styles.color.black};
  }
`;

export default AuthContainer;
